import React from "react";
import { useTranslation } from "react-i18next";
import { Flex, Icon, Text } from "@chakra-ui/react";
import { FaCookieBite } from "react-icons/fa";
import { ReactComponent as BrandTextIcon } from "../../assets/logo/smp-logo-with-text.svg";

const CookieDisabled = () => {
  const { t } = useTranslation(["common"]);

  return (
    <Flex alignItems="center" justifyContent="center" height="100vh" background="brand.dark_04">
      <Flex flexDirection="column" alignItems="center" maxWidth="18rem">
        <Icon
          as={FaCookieBite}
          color="brand.cream"
          fontSize="5rem"
        />
        <Text
          fontSize="2rem"
          lineHeight="1.1875"
          color="white"
          textAlign="center"
          marginTop="5"
        >
          {t("cookie_disabled.title")}
        </Text>
        <Text
          fontSize="md"
          lineHeight="1.25"
          color="white"
          textAlign="center"
          marginTop="2"
          sx={{
            span: {
              fontWeight: "bold",
              color: "primary.400",
            },
          }}
        >
          {t("cookie_disabled.description")}&nbsp;
          <Icon as={BrandTextIcon} width="auto" />
        </Text>
      </Flex>
    </Flex>
  );
};

export default CookieDisabled;
